/**
 * English message catalogue — the REFERENCE locale. Every key added here must
 * be added to ar.js in the same commit; `i18n-catalogue.test.js` fails
 * otherwise. Counted messages are objects keyed by CLDR plural category.
 */
export default {
  // Navigation labels. Keyed by a slug of the English label so `menuData.js`
  // stays the single source of menu STRUCTURE while the words live here —
  // switching locale must translate the chrome, not just flip its direction.
  nav: {
    app_gallery: 'App Gallery',
    generation_studio: 'Generation Studio',
    reel_generator: 'Reel Generator',
    media_library: 'Media Library',
    creative_studio: 'Creative Studio',
    animation_styles: 'Animation Styles',
    brand_elements_presets: 'Brand Elements & Presets',
    results_variants: 'Results & Variants',
    asset_vault_projects: 'Asset Vault & Projects',
    orchestration: 'Orchestration',
    workflows: 'Workflows',
    api_job_status: 'API Job Status',
    workflow_editor: 'Workflow Editor',
    review_quality: 'Review & Quality',
    review_queue: 'Review Queue',
    compliance_audit: 'Compliance & Audit',
    models_routing: 'Models & Routing',
    routing_policies: 'Routing Policies',
    model_registry: 'Model Registry',
    administration: 'Administration',
    users_roles: 'Users & Roles',
    workspaces_quotas: 'Workspaces & Quotas',
    api_credentials: 'API Credentials',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    export: 'Export',
    download: 'Download',
    language: 'Language',
    loading: 'Loading…',
    error: 'Something went wrong',
  },
  studio: {
    title: 'Creative Studio',
    greeting: 'Welcome back, {name}',
    prompt: 'Describe what you want to create',
    generate: 'Generate',
    variations: 'Try another variation',
  },
  library: {
    title: 'Media Library',
    assetCount: {
      zero: 'No assets',
      one: '1 asset',
      two: '2 assets',
      few: '{count} assets',
      many: '{count} assets',
      other: '{count} assets',
    },
  },
  reel: {
    title: 'Reel Generator',
    play: 'Play',
    pause: 'Pause',
    timeline: 'Timeline',
  },
  review: {
    title: 'Review & Approval',
    approve: 'Approve',
    reject: 'Request changes',
  },
  arabic: {
    headline: 'Arabic headline',
    overlayFont: 'Headline font',
    promptTranslated: 'Your Arabic prompt was translated to English for this model',
    originalPrompt: 'Original prompt (Arabic)',
    translatedPrompt: 'Prompt sent to the model',
  },
};
